import { useMutation } from '@tanstack/react-query';
import { UpdateChartDocPayload } from '../types/Chart/UpdateChartDocPayload';
import { ChartDocData } from '../types/Chart/Chart';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../constants/firebaseModular';
import * as Sentry from '@sentry/browser';

const updateChartSection = async (payload: UpdateChartDocPayload) => {
  const docTitle = Object.keys(payload.docData)[0];
  const docRef = doc(db, 'users', payload.patientId, 'Chart', docTitle);
  const data = payload.docData[docTitle as keyof ChartDocData];

  try {
    setDoc(docRef, data, { merge: true });
  } catch (error) {
    console.error('Error updating document from useUpdateChartSection hook: ', error);
    Sentry.captureException(error);
  }
};

export const useUpdateChartSection = () => {
  return useMutation({
    mutationFn: (payload: UpdateChartDocPayload) => updateChartSection(payload),
  });
};
